// removed by extract-text-webpack-plugin
module.exports = {"container":"_3L9DkIdcTJ3cTBBeEoRJ-n"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a26ee2d","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/rep-call/end-call-button/end-call-button.less
// module id = xLvN
// module chunks = 1